export default __webpack_public_path__ + "images/SpeakersPhotos/Benjamin_Lorente.jpg?fbd9d43a";